const skinDraw = (r) => require.ensure([], () => r(require('../views/natvip/skin-draw/index.vue')), 'skinDraw');
const skinDrawing = (r) => require.ensure([], () => r(require('../views/natvip/skin-draw/draw.vue')), 'skinDrawing');
const skinDrawing3D = (r) => require.ensure([], () => r(require('../views/natvip/skin-draw/draw3d.vue')), 'skinDrawing3D');
const qiBloodIndex = (r) => require.ensure([], () => r(require('../views/natvip/qi-blood/index.vue')), 'qiBloodIndex');
const qiBloodSubject = (r) => require.ensure([], () => r(require('../views/natvip/qi-blood/subject.vue')), 'qiBloodSubject');
const qiBloodReport = (r) => require.ensure([], () => r(require('../views/natvip/qi-blood/report.vue')), 'qiBloodReport');

// 各自开发路由的文件，最后在index.js中引入并合并到一起
const childOneRoutes = [
  {
    path: "/skin-draw",
    name: "skinDraw",
    component: skinDraw,
    meta: {
      title: "美白标记",
      // keepAlive: true,
    },
  },
  {
    path: "/skin-drawing",
    name: "skinDrawing",
    component: skinDrawing,
    meta: {
      title: "编辑美白标记",
    },
  },
  {
    path: "/skin-drawing3D",
    name: "skinDrawing3D",
    component: skinDrawing3D,
    meta: {
      title: "编辑美白3d标记",
      // keepAlive: true,
    },
  },
  {
    path: "/qi-blood-index",
    name: "qiBloodIndex",
    component: qiBloodIndex,
    meta: {
      title: "健康云图报告",
    },
  },
  {
    path: "/qi-blood-subject",
    name: "qiBloodSubject",
    component: qiBloodSubject,
    meta: {
      title: "元气评估主观题",
    },
  },
  {
    path: "/qi-blood-report",
    name: "qiBloodReport",
    component: qiBloodReport,
    meta: {
      title: "元气评估报告",
    },
  },
];

export default childOneRoutes;


// WEBPACK FOOTER //
// ./src/router/childOne.js